import debug from 'debug';
export function instantiateLogger(name) {
  var logger = debug(name);
  logger.log = console.log.bind(console);
  return logger;
}